import Flatpickr from 'react-flatpickr';
import { FieldError } from "./FieldError";
export const ClientDatePicker = ({
  guid,
  className,
  dateFormat,
  allowInput,
  enableTime,
  defaultDate,
  update = () => {},
  required,
  readOnly,
  label,
  error = false,
  errorText = '',
  onKeyDown,
  onBlur
}) => {
  const handleUpdate = (selectedDates, dateStr, instance) => {
    update(dateStr);
  };
  const filteredDate = defaultDate === 'BLANK' ? '' : defaultDate;
  return <>
      <Flatpickr key={`${guid}-${defaultDate}`} className={`${className} ${error && 'invalid '}`} value={filteredDate} options={{
      allowInput: allowInput,
      dateFormat: dateFormat,
      enableTime: enableTime,
      defaultDate: filteredDate,
      disableMobile: true,
      allowInput: false,
      enableTime: false
    }} onChange={handleUpdate} onClose={onBlur} disabled={readOnly} onKeyDown={onKeyDown} />
      <label className={`input-fields__label`}>
        {required ? `${label}*` : `${label}`}
      </label>
      {error && <FieldError errorText={errorText} />}
    </>;
};